import * as cookie from '../cookie-utils';
import { Guid } from 'guid';
const newGuid = Guid.MakeNew().ToString().toLowerCase();

export const getGuid = () => {
  if (cookie.cookieNames?.logging.correlationToken) {
    const cookieGuid = cookie.readCookie(cookie.cookieNames?.logging.correlationToken);
    if (cookieGuid) {
      return cookieGuid;
    }
    cookie.setCookie(cookie.cookieNames?.logging.correlationToken, newGuid, { path: '/', secure: true, sameSite: 'lax' });
    return newGuid;
  }
  return '';
};

export const generateTransactionGUID = (correlationId: string) => {
  const correlationIdChunks = correlationId.split('-');
  const transactionIdGuid = Guid.MakeNew().ToString().toLowerCase();
  const transactionIdChunks = transactionIdGuid.split('-');
  transactionIdChunks[0] = correlationIdChunks[0];
  return transactionIdChunks.join('-');
};
